var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"insights-filters"}},[_c('StructureSelect',{attrs:{"images":_vm.reformattedImages,"index":_vm.index,"pImages":_vm.pImages}}),_c('FaultSummaryFilters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }